module.exports = __webpack_public_path__ + "static/media/ebookconversionActive.83c60753.svg";